<template>
  <div id="app">
<!--    <h-header/>-->
    <h-layout>
      <router-view/>
    </h-layout>
    <!-- footer -->
  </div>
</template>
<script>
import HLayout from '@/components/layout/HLayout.vue'
// import HHeader from '@/components/layout/HHeader.vue'
import { getDomain, handleRedirectReferer } from '@/utils'

export default {
  name: 'RootPage',
  components: { HLayout },
  async created() {
    // The authorization view owns its account lookup and expired-session UX.
    if (window.location.pathname === '/identity/authorize') return
    // if token exists then fetch user info by token
    if (this.$store.state.token) {
      const res = await this.$store.dispatch('getUser')
      if (res.code === 0 && this.$store.state.referer) handleRedirectReferer(this.$store.state.referer, this.$store.state.token, this.$store.state.queryToken)
    }
  },
  mounted() {
    // The shared navbar forwards the current query string to its links.
    // Authorization state and nonce must stay on this page.
    if (window.location.pathname === '/identity/authorize') return
    const domain = getDomain()
    const [subdomain] = domain.split('.')
    const navbar = document.createElement('script')
    // sandbox & production filename
    const filename = subdomain.slice(0, 1) === 's' || process.env.NODE_ENV !== 'production'
      ? 'navbar-test.js'
      : 'navbar.js'
    navbar.src = `${process.env.VUE_APP_CLOUD_SOTRAGE_URL}/h365-landing-page/public/js/${filename}`
    navbar.src += `?env=${process.env.NODE_ENV}`
    navbar.src += '&source=account'

    document.body.insertAdjacentElement('beforeend', navbar)
  }
}
</script>
